<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { ConfigStore } from '../lib/store/config';
  import SvgIcon from '../lib/components/svg-icon.svelte';
  import { canSwitchModes } from './types';
  import { voiceState, switchVoiceMode } from './bridge';
</script>

{#if !$voiceState.active && canSwitchModes($ConfigStore.widget?.live)}
  <button type="button" class="cs-text-switch" on:click={switchVoiceMode}>
    <SvgIcon name="message-circle" />
    <span>{$_('voice.switch_text')}</span>
  </button>
{/if}

<style>
  .cs-text-switch {
    align-self: center;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    max-width: 100%;
    min-height: 44px;
    padding: 8px 14px;
    border: 1px solid #8885;
    border-radius: 10px;
    background: transparent;
    color: inherit;
    font: inherit;
    font-size: 14px;
    cursor: pointer;
  }
  .cs-text-switch:hover { background: #8882; }
  .cs-text-switch:focus-visible { outline: 2px solid currentColor; outline-offset: 2px; }
</style>
